import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import LoginIcon from "@mui/icons-material/Login";
import { Avatar, Box, Button, Chip, CircularProgress, Divider, IconButton, Modal, Tooltip } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { decode } from "base-64";
import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from "../auth/Token";
import CashFlowReports from "../components/CashFlowReports";
import Header from "../components/Header";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#dee2e6",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  marginTop: "30px",
  marginBottom: "130px",
  borderRadius: "8px",
}));

const AssociationKinds = ({ isOnline }) => {
  const [apiResponse, setApiResponse] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const society_id = id;
  const [open, setOpen] = useState(false);
  const [name, setMename] = useState("");
  const { permissions } = useContext(AuthContext);
  const [clusters, setClusters] = useState([]);
  const [formData, setFormData] = React.useState({
    association_type: "",
    open_date: new Date(),
    society_id: society_id,
  });
  const [modal_open, setModal_open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [me, setMe] = useState([]);
  const [all_facilitators, setAll_facilitators] = useState([]);
  const [openMode, setOpenMode] = useState(false);
  const [current_clus, setCurrent_clus] = useState(null);
  const [show_reports, setShow_reports] = useState(false);
  const [society_data, setSociety_data] = useState([]);
  const [updateName, setUpdateName] = useState(false);

  const handleLoans = () => {
    navigate("/society-loans", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }


  const handleTeams = () => {
    navigate("/teams", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }

  const handleStockManeger = () => {
    navigate("/stocks", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }

  const handleMembers = () => {
    navigate("/members", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }

  const handleExpenses = () => {
    navigate("/expenses", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }

  const handleAssets = () => {
    navigate("/assets", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }

  const handleHr = (society_id) => {
    navigate("/users", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }

  const handleSubsc = () => {
    navigate("/subscriptions", {
      state: { 
        society_id: society_id,
        name: name
      }
    });
  }



  const aggre_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 520,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const handleNewFac = (clus_id) => {
    setCurrent_clus(clus_id);
    setOpenMode(true);
  };

  const fetch_clusters = () => {
    const storedClusters = localStorage.getItem(`clusters_${id}`);
    const storedMe = localStorage.getItem("me");
    const storedFacilis = localStorage.getItem("facilis");

    if (!isOnline) {
      setAll_facilitators(JSON.parse(storedFacilis));
    } else {
      api
        .get("/account/all/facilitators", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setAll_facilitators(response.data?.facilitators);
          localStorage.setItem(
            "facilis",
            JSON.stringify(response.data?.facilitators)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (!isOnline) {
      setClusters(JSON.parse(storedClusters));
    } else {
      api
        .get(`/association/get/clusters/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setClusters(response.data?.all);
          localStorage.setItem(
            `clusters_${id}`,
            JSON.stringify(response.data?.all)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (!isOnline) {
      setMe(JSON.parse(storedMe));
    } else {
      api
        .get("/users/su", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setMe(response.data);
          localStorage.setItem("me", JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    fetch_clusters();
  }, [id]);

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const fetchClustersOnline = () => {
    api
      .get(`/association/get/clusters/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setClusters(response.data?.all);
        localStorage.setItem(
          `clusters_${id}`,
          JSON.stringify(response.data?.all)
        );
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleNewFacilis = (id) => {
    const data = new FormData();
    data.append("cluster_id", current_clus);
    data.append("facilitator_id", id);

    api
      .post("/account/set/facilitator", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        setOpenMode(false);
        setCurrent_clus(null);
        fetchClustersOnline();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const sec_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 320,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };
  const closeam = () => {
    setModal_open(false);
  };

  const formik = useFormik({
    initialValues: {
      cluster_name: "",
      cluster_office: "",
      cluster_head: "",
    },
    validationSchema: Yup.object({
      cluster_name: Yup.string().required("Cluster name should not be empty"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("cluster_name", values.cluster_name);
      data.append("society_id", society_id);
      data.append("cluster_office", values.cluster_office);
      data.append("cluster_head", values.cluster_head);
      api
        .post("/association/create/cluster", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          fetch_clusters();
          closeam();
          formik.handleReset();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          setLoading(false);
        });
    },
  });

  const society_formik = useFormik({
    initialValues: {
      society_name: "",
      society_office: "",
      society_phone: "",
      society_email: "",
      value_chain: "",
      gra_pin: "",
    },
    onSubmit: (values) => {
      const data = new FormData();
      data.append(
        "society_name",
        values.society_name === "" ? society_data?.society : values.society_name
      );
      data.append("society_id", society_id);
      data.append(
        "society_office",
        values.society_office === ""
          ? society_data?.office
          : values.society_office
      );
      data.append(
        "society_phone",
        values.society_phone === "" ? society_data?.phone : values.society_phone
      );
      data.append(
        "society_email",
        values.society_email === "" ? society_data?.email : values.society_email
      );
      data.append(
        "value_chain",
        values.value_chain === "" ? society_data?.value_chain : values.value_chain
      );
      data.append(
        "gra_pin",
        values.gra_pin === "" ? society_data?.gra_pin : values.gra_pin
      );

      toast.promise(
        api.post("/association/update/society", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: "Updating...",
          success: (response) => {
            handleCloseSociety();
            getAssociationKinds();

            return response.data;
          },
          error: (error) => {
            console.log(error);

            return "An error occurred, please refresh the page";
          },
        }
      );
    },
  });

  const handleInputChange = (event) => {
    const value = event.target.value;
    setFormData({
      ...formData,
      [event.target.name]: value,
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getAssociationKinds = () => {
    const storedAssociationKinds = localStorage.getItem(
      `association_kinds_${society_id}`
    );

    if (!isOnline) {
      const parsedData = JSON.parse(storedAssociationKinds);
      setApiResponse(parsedData.types);
      setMename(parsedData.place.society);
    } else {
      api
        .get(`/association/types/${society_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setApiResponse(response.data?.types);
          setMename(response.data?.place.society);
          setSociety_data(response.data?.place);
          localStorage.setItem(
            `association_kinds_${society_id}`,
            JSON.stringify(response.data)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    getAssociationKinds();
  }, [id]);

  const handleCloseSociety = () => {
    setUpdateName(false);
    society_formik.handleReset();
  };

  const handleClick = (id) => {
    try {
      api
        .get(`/association/type/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          if (response.status === 200 && response.data) {
            navigate("/onekind/", {
              state: { responseInfo: response.data, society_id: society_id },
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  const createAm = async (event) => {
    event.preventDefault();
    try {
      await api
        .post("/association/create/type", formData, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          handleClose();
          getAssociationKinds();
          setFormData({
            association_type: "",
            open_date: new Date(),
            society_id: society_id,
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleAccount = (id) => {
    navigate("/accounts/society", { state: { society_id: id, name: name } });
  };

  const handleAccountLogistics = (id) => {
    navigate("/request/logistics", { state: { society_id: id, name: name } });
  };

  const handleCommodityWarehouse = (id, name) => {
    navigate("/manage/commodities", {
      state: {
        society_id: id,
        name: name,
      },
    });
  };

  const handleCommodity = (id, name) => {
    navigate("/commodities", {
      state: {
        society_id: id,
        name: name,
      },
    });
  };

  const handleSeasons = (id, name) => {
    navigate("/seasons", {
      state: {
        society_id: id,
        name: name,
      },
    });
  };

  const gotoCluster = (id, c_name, office) => {
    navigate("/cluster", {
      state: {
        cluster_id: id,
        society_name: name,
        society_id: society_id,
        cluster_name: c_name,
        cluster_office: office,
      },
    });
  };

  // console.log(permissions);
  if (permissions && permissions.view_society === true) {
    return (
      <div className="app">
        <main className="content">
          <Box sx={{ m: 5 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title="Society Clusters" />
            </Box>
            <Box>
              <Typography
                sx={{ textAlign: "center" }}
                variant="h3"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{society_data?.society}</b>
              </Typography>
            </Box>
            {me.role_name === "Supervisors" ? null : (
              <>
                {permissions && permissions.view_society_account === true ? (
                  <Button
                    onClick={() => handleAccount(society_id)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Account</b>
                    </Typography>
                  </Button>
                ) : null}
                
                {me.role_name === "Administrator" || me.role_name === "Operations Manager" || me.role_name === "Society Manager"? (
                  <Button
                    onClick={() => handleHr(society_id)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Human Resource (HR)</b>
                    </Typography>
                  </Button>
                ): null}
                
                {me.role_name === "Administrator" || me.role_name === "Operations Manager" || me.role_name === "Society Manager"? (
                  <Button
                    onClick={() => handleSubsc(society_id)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Subscriptions</b>
                    </Typography>
                  </Button>
                ): null}

                {me.role_name === "Administrator" || me.role_name === "Operations Manager" || me.role_name === "Society Manager"? (
                  <Button
                    onClick={() => handleAccountLogistics(society_id)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Request Logistics</b>
                    </Typography>
                  </Button>
                ) : null}
                {me.role_name === "Administrator" || me.role_name === "Operations Manager" || me.role_name === "Society Manager"? (
                  <Button
                    onClick={() => handleStockManeger(society_id)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Stock Manager</b>
                    </Typography>
                  </Button>
                ) : null}

                {permissions && permissions.update_society === true ? (
                  <Button
                    onClick={() => setUpdateName(true)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Society Details</b>
                    </Typography>
                  </Button>
                ) : null}
                {permissions && permissions.view_warehouse === true ? (
                  <Button
                    onClick={() => handleCommodityWarehouse(society_id, name)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Manage Warehouse</b>
                    </Typography>
                  </Button>
                ) : null}
                {permissions ? (
                  <Button
                    size="medium"
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={() => handleCommodity(society_id, name)}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Manage Commodities</b>
                    </Typography>
                  </Button>
                ) : null}

                <Button
                  size="medium"
                  color="success"
                  variant="contained"
                  sx={{
                    borderRadius: 2,
                    m: 1,
                    backgroundColor: "#000",
                    color: "#fff",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                    },
                  }}
                  onClick={() => handleSeasons(society_id, name)}
                >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Farming Seasons</b>
                    </Typography>
                </Button>
                <Button
                  size="medium"
                  color="success"
                  variant="contained"
                  sx={{
                    borderRadius: 2,
                    m: 1,
                    backgroundColor: "#000",
                    color: "#fff",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                    },
                  }}
                  onClick={handleMembers}
                >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Members</b>
                    </Typography>
                </Button>

                <Button
                    onClick={() => handleExpenses(society_id)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Expenses</b>
                    </Typography>
                  </Button>
              </>
            )}

              {me.role_name === "Administrator" || me.role_name === "Operations Manager" || me.role_name === "Society Manager"? (
                  <Button
                    onClick={handleAssets}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Society Assets</b>
                    </Typography>
                  </Button>
                ) : null}
              {me.role_name === "Administrator" ? (
                  <Button
                    onClick={handleTeams}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Teams Manager</b>
                    </Typography>
                  </Button>
                ) : null}
              {me.role_name === "Administrator" || me.role_name === "Operations Manager" || me.role_name === "Society Manager"? (
                  <Button
                    onClick={handleLoans}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Society Loans</b>
                    </Typography>
                  </Button>
                ) : null}

            <Divider variant="middle" sx={{ my: 5 }} />
            {me.role_name === "Administrator" ||
            me.role_name === "Operations Manager" ||
             me.role_name === "Society Manager"? (
              <Chip
                size="small"
                label={
                  <Typography
                    variant="subtitle"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      {show_reports
                        ? "Back to Clusters"
                        : "Cash Flow Reports & Insights"}
                    </b>
                  </Typography>
                }
                icon={
                  show_reports ? (
                    <KeyboardBackspaceRoundedIcon sx={{ color: "#fff" }} />
                  ) : null
                }
                sx={{
                  borderRadius: 2,
                  m: 1,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#2b2d42",
                  color: "#fff",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                  },
                }}
                onClick={() => setShow_reports((prev) => !prev)}
              />
            ) : null}
            {!show_reports ? (
              <Item>
                <Typography
                  gutterBottom
                  variant="h4"
                  component="div"
                  sx={{ margin: "5px", color: "#003049" }}
                  fontStyle="normal"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Clusters</b>
                </Typography>
                {me.role_name === "Supervisors" ? null : (
                  <Typography fontStyle="italic" variant="subtitle">
                    <b>Create cluster</b>
                    <IconButton onClick={() => setModal_open(true)}>
                      <AddBoxIcon />
                    </IconButton>
                  </Typography>
                )}

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxHeight: 550,
                    overflowY: "auto",
                  }}
                >
                  {clusters.map((cluster) => (
                    <Card sx={{ maxWidth: 280, margin: 4, borderRadius: 7 }}>
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          {cluster.cluster_name}
                        </Typography>
                      </CardContent>
                      <CardActions>
                        {!cluster.username ? (
                          <Chip
                            key={cluster.cluster_id}
                            size="small"
                            label={
                              <Typography
                                variant="subtitle"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Main Facilitator</b>
                              </Typography>
                            }
                            sx={{
                              borderRadius: 2,
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#2b2d42",
                              color: "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                              },
                            }}
                            onClick={() => handleNewFac(cluster.cluster_id)}
                          />
                        ) : (
                          <Tooltip
                            title="Facilitator"
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>{cluster.username}</b>
                            </Typography>
                            <IconButton
                              sx={{ ml: 1 }}
                              onClick={() => handleNewFac(cluster.cluster_id)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                        {me.role_name === "Supervisors" ? null : (
                          <IconButton
                            onClick={() =>
                              gotoCluster(
                                cluster.cluster_id,
                                cluster.cluster_name,
                                cluster.cluster_office
                              )
                            }
                            // disabled={me.role_name === "Senior Facilitator" && cluster.username == me.username? false:true}
                          >
                            <LoginIcon />
                          </IconButton>
                        )}
                      </CardActions>
                    </Card>
                  ))}
                  {/* {
                                                    clusters.map((cluster) => (
                                                        <>
                                                            <div style={{ display:'flex' }}>
                                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" fontStyle='initial' variant='h6'><b>{cluster.cluster_name}</b>
                                                                <IconButton sx={{ ml:20 }} onClick={() => gotoCluster(cluster.cluster_id, cluster.cluster_name, cluster.cluster_office)}>
                                                                    <LoginIcon />
                                                                </IconButton>   
                                                                </Typography>
                                                            </div>
                                                            <Divider variant='middle'/>
                                                        </>
                                                    ))
                                                } */}
                </Box>
              </Item>
            ) : (
              <CashFlowReports society_id={society_id} name={name} />
            )}

            {/* </Grid>
                            <Grid item container xs={12} md={8}> 
                                    <div style={{ display:'flex', flexWrap:'wrap', maxHeight: 450, overflowY:'scroll'}}> 
                                {apiResponse.map((assoKind) => ( 
                                        <Card sx={{ minWidth: 280, margin: 4 }}>
                                            <CardContent>
                                            <Typography gutterBottom variant="h5" component="div">
                                                {assoKind.association_type}
                                            </Typography>
                                            </CardContent>
                                            <CardActions>
                                            <IconButton onClick={() => handleClick(assoKind.associationtype_id)}>
                                            <LoginIcon />
                                            </IconButton>
                                            </CardActions>
                                        </Card>
                                ))} 
                                    </div> 
                            </Grid>

                            </Grid>  */}

            <Modal
              open={openMode}
              onClose={() => setOpenMode(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={aggre_style}>
                {all_facilitators ? (
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.paper",
                    }}
                  >
                    {all_facilitators.map((item) => (
                      <>
                        <ListItem
                          alignItems="flex-start"
                          onClick={() => handleNewFacilis(item.user_id)}
                          sx={{ cursor: "pointer" }}
                          // secondaryAction={
                          //   <IconButton
                          //     onClick={() => handleNewFacilis(item.user_id)}
                          //     edge="end"
                          //     aria-label="comments"
                          //   >
                          //     <CheckCircleIcon
                          //       color={
                          //         item.fullname === facilitator
                          //           ? "success"
                          //           : "primary"
                          //       }
                          //     />
                          //   </IconButton>
                          // }
                        >
                          <ListItemAvatar>
                            <Avatar
                              alt="facilitator"
                              src={pic(item.picture_img)}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={item.fullname}
                            secondary={
                              <Box sx={{ display: "block" }}>
                                <div>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    Contact: <b>{item.phone}</b>
                                  </Typography>
                                </div>
                                <div>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    Society: <b>{item.society}</b>
                                  </Typography>
                                </div>
                              </Box>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </>
                    ))}
                  </List>
                ) : (
                  <Box sx={{ display: "flex", textAlign: "center" }}>
                    <Typography>No Facilitators found</Typography>
                  </Box>
                )}
              </Box>
            </Modal>

            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Setup Savings Group Kind</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  You will be able to Register new Savings Groups after the
                  setup.
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="association_type"
                  name="association_type"
                  label="Name"
                  onChange={handleInputChange}
                  value={formData.association_type}
                  type="text"
                  fullWidth
                  variant="outlined"
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={createAm}>Create</Button>
              </DialogActions>
            </Dialog>

            <Modal
              open={modal_open}
              onClose={closeam}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={sec_style}>
                <Typography sx={{ textAlign: "center" }} fontStyle="oblique">
                  <b>New Cluster</b>
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                  <div style={{ margin: "5px" }}>
                    <TextField
                      size="small"
                      value={formik.values.cluster_name}
                      name="cluster_name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.cluster_name &&
                        Boolean(formik.errors.cluster_name)
                      }
                      helperText={
                        formik.touched.cluster_name &&
                        formik.errors.cluster_name
                      }
                      sx={{ m: 1 }}
                      variant="outlined"
                      label="Cluster Name"
                    />
                    <TextField
                      size="small"
                      value={formik.values.cluster_office}
                      name="cluster_office"
                      onChange={formik.handleChange}
                      sx={{ m: 1 }}
                      variant="outlined"
                      label="Office Address"
                    />
                  </div>

                  <div style={{ display: "flex" }}>
                    <Button
                      sx={{ m: 1 }}
                      size="small"
                      variant="contained"
                      color="error"
                      onClick={closeam}
                    >
                      Cancel
                    </Button>
                    <Button
                      sx={{ m: 1 }}
                      type="submit"
                      size="small"
                      variant="contained"
                      color="success"
                      disabled={loading}
                    >
                      {loading === true ? (
                        <CircularProgress color="info" size="20px" />
                      ) : (
                        "Create"
                      )}
                    </Button>
                  </div>
                </form>
              </Box>
            </Modal>

            <Modal
              open={updateName}
              onClose={handleCloseSociety}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Typography
                      variant="h5"
                      sx={{ textAlign: "center", m: 1 }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Society Details</b>
                    </Typography>

                    <TextField
                      sx={{ m: 1 }}
                      size="small"
                      name="society_name"
                      type="text"
                      value={society_formik.values.society_name}
                      onChange={society_formik.handleChange}
                      placeholder={society_data?.society}
                      helperText="Society Name"
                      fullWidth
                    />
                    <TextField
                      sx={{ m: 1 }}
                      size="small"
                      name="society_office"
                      type="text"
                      value={society_formik.values.society_office}
                      onChange={society_formik.handleChange}
                      placeholder={society_data?.office}
                      helperText="Office Address"
                      fullWidth
                    />
                    <TextField
                      sx={{ m: 1 }}
                      size="small"
                      name="society_phone"
                      type="text"
                      placeholder={society_data?.phone}
                      helperText="Phone"
                      value={society_formik.values.society_phone}
                      onChange={society_formik.handleChange}
                      fullWidth
                    />
                    <TextField
                      sx={{ m: 1 }}
                      size="small"
                      name="society_email"
                      type="email"
                      placeholder={society_data?.email}
                      helperText="email"
                      value={society_formik.values.society_email}
                      onChange={society_formik.handleChange}
                      fullWidth
                    />
                    <TextField
                      sx={{ m: 1 }}
                      size="small"
                      name="value_chain"
                      type="text"
                      placeholder={society_data?.value_chain}
                      helperText="Value chain"
                      value={society_formik.values.value_chain}
                      onChange={society_formik.handleChange}
                      fullWidth
                    />
                    <TextField
                      sx={{ m: 1 }}
                      size="small"
                      name="gra_pin"
                      type="text"
                      placeholder={society_data?.gra_pin}
                      helperText="GRA Pin"
                      value={society_formik.values.gra_pin}
                      onChange={society_formik.handleChange}
                      fullWidth
                    />

                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Button
                        size="small"
                        color="error"
                        variant="contained"
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={handleCloseSociety}
                      >
                        Close
                      </Button>

                      <Button
                        size="small"
                        color="success"
                        variant="contained"
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={society_formik.handleSubmit}
                      >
                        Update
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Modal>
          </Box>
        </main>
      </div>
    );
  } else {
    return (
      <div className="app">
        <main className="content">
          <Box sx={{ m: 1 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header
                title={
                  typeof name === "string" &&
                  name.includes("Society" || "society")
                    ? name
                    : `${name} Society`
                }
                subtitle="Savings Groups"
              />
            </Box>
            <Typography variant="h4" sx={{ textAlign: "center" }}>
              Not Authorized 🙅🏾‍♂️
            </Typography>
          </Box>
        </main>
      </div>
    );
  }
};

export default AssociationKinds;
